/**
 * Quotes from the people the work was for. The bundled entries are DRAFT
 * COPY — realistic samples, not transcribed from real interviews — and stand
 * only until the CMS has answered: from then on this list is exactly what the
 * CMS publishes (consent recorded for every one), and empty means the
 * section is not shown.
 */

const AUTHOR = '/landing/testimonials/author-new.webp';

export interface TestimonialItem {
    quote: string;
    name: string;
    /** Role or place; may be empty. */
    role: string;
    /** Portrait; empty means the card shows the initials. */
    avatar: string;
    initials: string;
}

export const initialsOf = (name: string): string =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');

export const TESTIMONIALS: TestimonialItem[] = [
    {
        name: 'Client, Ibadan',
        role: 'Legal Aid — pre-trial detention',
        quote: 'I had been inside for months and nobody could tell me why. The lawyer they sent found my file in a week. I was home before the next month ended.',
        avatar: AUTHOR,
        initials: 'CI',
    },
    {
        name: 'Volunteer Solicitor',
        role: 'Police Duty Solicitor Scheme',
        quote: 'You go into the station expecting complicated legal work, and half of what you actually do is ask where a file is. It is astonishing how far that one question gets you.',
        avatar: AUTHOR,
        initials: 'VS',
    },
    {
        name: 'Community Paralegal',
        role: 'Partner organisation, Oyo State',
        quote: 'People trust us because they already know us. Being able to hand someone straight to a real lawyer instead of a phone number changed what that trust is worth.',
        avatar: AUTHOR,
        initials: 'CP',
    },
    {
        name: 'Court Registrar',
        role: 'State High Court',
        quote: 'Nobody enjoys seeing their court ranked. But the numbers were ours to begin with, and they made the case for more listing days better than we ever had.',
        avatar: AUTHOR,
        initials: 'CR',
    },
];
